import Request from 'modules/request'

const handlerStatuscode = (statusCode, data) => {
  console.log(statusCode);
  switch (statusCode) {
    case 200:
      document.getElementById('data-content').innerHTML = data;
      break;
    case 401:
      console.log(statusCode);
      break;
    default:
      console.log(`O CODIGO DE RESPOSTA É: ${statusCode}`);
  }
}

export default class DeviceProducer {
    
    getAll(url) {
        Dashboard.setCurrentPage('devices');
        const request = new Request();
        request.get(url, (request, response) => {
          handlerStatuscode(response.statusCode, response.data)
        });
    }

    DeviceNew(url)
    {
        Dashboard.setCurrentPage('devices');
        const request = new Request();
        request.get(url, (request, response) => {
          handlerStatuscode(response.statusCode, response.data)
        });

    }

    GetManager(url)
    {
        Dashboard.setCurrentPage('devices');
        const request = new Request();
        request.get(url, (request, response) => {
          handlerStatuscode(response.statusCode, response.data)
        });
    }

    Delete(url)
    {
        Dashboard.setCurrentPage('devices');
        const request = new Request();
        request.get(url, (request, response) => {
          handlerStatuscode(response.statusCode, response.data);
          let data = JSON.parse(response.data);
          this.getAll(data.redirect);
        });
    }

    Submit(url)
    {
        let auth_token = document.getElementsByName('authenticity_token')[0].value;
        let name = document.getElementById('device_producer_name').value;
        let mac_address = document.getElementById('device_producer_mac_address').value;
        let user = document.getElementById('device_producer_user_id').value;

        let params = null;
        params = `authenticity_token=${auth_token}&device_producer[name]=${name}&device_producer[mac_address]=${mac_address}&device_producer[user_id]=${user}`;

        const request = new Request();
        request.post(url, params, (request, response) => {
            let data = JSON.parse(response.data);
            Notify.delivery(response.data);
            this.getAll(data.redirect);
        });
    }
}